import http from "./http";

// List all permissions for every role the system knows about.
// Returns: { status, data: { super_admin: [...], admin: [...], sales: [...] } }
export const getRolePermissions = async () => {
  const res = await http.get("role_permissions");
  return res.data;
};

// Replace the permission set for a single role.
export const updateRolePermissions = async (role, permissions) => {
  const res = await http.put("role_permissions", { role, permissions });
  return res.data;
};
